'use strict';

if (typeof Promise === 'function') {
  require('promise.prototype.finally/auto'); // eslint-disable-line global-require
}

require('./es2019');



//////////////////
// WEBPACK FOOTER
// ./~/airbnb-js-shims/target/es2018.js
// module id = 840
// module chunks = 0